import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import ErrorImg from '@/assets/imgs/unknown-error.svg';
import { AnalyticsOrigination, AnalyticsStepNumber } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';
import { registerEventKO } from '@/services/analytics';
import { RootState } from '@/store';

import Auxiliary from '../Auxiliary';

interface UnknownErrorProps {
  step: AnalyticsStepNumber;
  handleClose: () => void;
}

export default function UnknownError({ step, handleClose }: UnknownErrorProps) {
  const creditProposal = useSelector(
    (state: RootState) => state.creditProposal.data,
  );

  useEffect(() => {
    registerEventKO({
      origin: AnalyticsOrigination.App,
      uuid: creditProposal?.credit_proposal_id,
    }, step.toString());
  }, []);

  return (
    <Auxiliary
      screen="unknown-error"
      title="¡Ups! Algo ha ido mal..."
      subtitle="Por favor, vuelve a intentarlo."
      imgSrc={ErrorImg}
      mainButton="Volver"
      handleMainButton={() => handleClose()}
    />
  );
}
